// hooks/useDownloadProgress.js
import { useEffect, useRef, useState } from 'react';
import { utilities as csUtils } from '@cornerstonejs/core';

const useDownloadProgress = () => {
  const downloadIdRef = useRef(csUtils.uuidv4());

  const getDownloadUrl = (flag, studyUID, type, seriesUID?, instanceUID?) => {
    // const baseUrl = `/wadors/download`; //910医院用这个
    const baseUrl = `/api/download`; //其他医院用这个
    const params = new URLSearchParams({ downloadId: downloadIdRef.current });

    switch (flag) {
      case 'studies':
        return `${baseUrl}/studies/${studyUID}/${type}?${params}`;
      case 'series':
        return `${baseUrl}/studies/${studyUID}/series/${seriesUID}/${type}?${params}`;
      case 'instances':
        return `${baseUrl}/studies/${studyUID}/series/${seriesUID}/instances/${instanceUID}/${type}?${params}`;
      default:
        throw new Error(`未知的下载类型: ${flag}`);
    }
  };
  return {
    getDownloadUrl,
    downloadId: downloadIdRef.current,
  };
};

export default useDownloadProgress;
